<header>
  @if (cartSubTotalFees() > 0) {
    <div class="line">
      <div>+Fees:</div>
      <span [innerHTML]="cartSubTotalFees() | currencyHtml"></span>
    </div>
  }
  <div class="line">
    <div>Sub Total:</div>
    <span [innerHTML]="cartSubTotalWithFees() | currencyHtml"></span>
  </div>
  <button mat-stroked-button (click)="checkout()" [disabled]="cartItemCount() === 0 || checkoutBusy()">{{ checkoutLabel() }}</button>
</header>
<div cdk-scrollable cdkVirtualScrollingElement>
  <ideal-cart-item-results></ideal-cart-item-results>
</div>
<div tools>
  <div toolbar>
    @if (isAuthenticated()) {
      <button mat-stroked-button (click)="promptSaveCart()" [disabled]="cartItemCount() === 0"><mat-icon>save</mat-icon>Save Cart</button>
      <button mat-stroked-button (click)="promptSaveList()" [disabled]="cartItemCount() === 0"><mat-icon>save</mat-icon>Save List</button>
    }
    <button mat-stroked-button clear class="warn" (click)="promptClear()" [disabled]="cartItemCount() === 0">
      <mat-icon>delete</mat-icon>Clear Cart
    </button>
  </div>
</div>
